import * as React from "react";
import { useContext } from "react";
import { Link, Tooltip } from "components/common";
import useFailuresOverview from "failure/hooks/useFailuresOverview";
import { DEFAULT_TIMERANGE } from "views/Constants";
import SearchLink from "views/logic/search/SearchLink";
import { createElasticsearchQueryString } from "views/logic/queries/Query";
import StreamsContext from "contexts/StreamsContext";
const buildSearchLink = (streamIds, failureType, inputId) => SearchLink.builder().timerange(DEFAULT_TIMERANGE).query(createElasticsearchQueryString(`gl2_source_input:${inputId} AND failure_type:${failureType}`)).streams(streamIds).build().toURL();
const InputFailureLink = ({ children = null, failureType, inputId }) => {
  var _a;
  const { data, isSuccess } = useFailuresOverview();
  const streams = useContext(StreamsContext);
  const failureStream = streams == null ? void 0 : streams.find((stream) => stream.title.includes("Failures"));
  if (!isSuccess) {
    return children;
  }
  if (!((_a = data[failureType]) == null ? void 0 : _a.enabled)) {
    return /* @__PURE__ */ React.createElement(
      Tooltip,
      {
        withArrow: true,
        position: "top",
        label: `The ${failureType} failure logging is disabled, please enable it to see the links to the logs.`
      },
      /* @__PURE__ */ React.createElement("span", null, children)
    );
  }
  return /* @__PURE__ */ React.createElement(Link, { to: buildSearchLink([failureStream == null ? void 0 : failureStream.id], failureType, inputId) }, children);
};
export default InputFailureLink;
